import { render, staticRenderFns } from "./AppSaveEditLocation.vue?vue&type=template&id=182f475c&scoped=true&"
import script from "./AppSaveEditLocation.vue?vue&type=script&lang=ts&"
export * from "./AppSaveEditLocation.vue?vue&type=script&lang=ts&"
import style0 from "./AppSaveEditLocation.vue?vue&type=style&index=0&id=182f475c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182f475c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
